module.exports = __webpack_public_path__ + "iphone.svg?f37fa39e431a43b809e7f3534090f385";